import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import { Typography, Modal } from '@material-ui/core';
import Button from '../components/Button';

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const styles = theme => ({
  paper: {
    position: 'absolute',
    width: theme.spacing.unit * 65,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
    fontFamily: "Arial",
  },
});

class MapLocation extends React.Component {
  state = {
    open: false,
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
          <Button variant="stroked" onClick={this.handleOpen}>Vaata asukohti</Button>

        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
        >
          <div style={getModalStyle()} className={classes.paper}>
            <Typography variant="Subheading" id="simple-modal-description">
              Kaardil nähtavates asukohtades toimuvad sünnipäevamatkad.
            </Typography>
            <iframe src="https://www.google.com/maps/d/embed?mid=1_fUdt_nyINvmB_NP_shrsYhtR0p8gRTF"
                width="450" height="450">
            </iframe>
          </div>
        </Modal>
      </div>
    );
  }
}

MapLocation.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MapLocation);



// WEBPACK FOOTER //
// ./src/components/MapLocation.js